import type { Dict } from './index';

// Hintçe sözlük — Claude tarafından elle çevrildi (06.08.2026), makine
// çevirisi kullanılmadı. en.ts ile aynı yapıda olmalı (tip zorunlu kılar).
export const hi: Dict = {
  signInMethods: {
    googleLinked: "Google खाता जुड़ा हुआ है।",
    googleCodeSent: "आपके पंजीकृत नंबर पर कोड भेजा गया है, जिसके अंतिम अंक {phone} हैं।",
    googleChooseHint: "आप जो Google खाता चुनेंगे, वह इस nosubject खाते में साइन इन करने के लिए जोड़ा जाएगा।",
    googleStatusUnknown: "Google कनेक्शन की स्थिति जाँची नहीं जा सकी। कृपया दोबारा जाँचें।",
    googleLinkIntro: "Google जोड़ने से पहले इस खाते में पंजीकृत फ़ोन नंबर की पुष्टि करें।",
    googleLinkFailed: "अनुरोध पूरा नहीं हो सका। कृपया फिर से कोशिश करें।",
    googleSendCode: "पुष्टि कोड भेजें",
    googleCodeLabel: "पुष्टि कोड",
    googleStartAgain: "फिर से शुरू करें",
    googleContinue: "Google से जारी रखें",
    googleFailed: "Google से साइन इन पूरा नहीं हो सका। कृपया फिर से कोशिश करें।",
    googleNotLinked: "यह Google खाता अभी किसी nosubject खाते से जुड़ा नहीं है।",
    googleUnavailable: "Google से साइन इन अभी उपलब्ध नहीं है।",
    title: "साइन-इन के तरीके",
    intro: "यह अनुभाग तैयार किया जा रहा है। साइन-इन के तरीकों को प्रबंधित करने के विकल्प बाद में जोड़े जाएंगे।",
    identity: "पहचान सत्यापन",
    identityInfo: "अपनी पहचान सत्यापित करना और अपने खाते में साइन इन करना अलग-अलग प्रक्रियाएँ हैं।",
  },
  safety: {
    title: 'सुरक्षा नंबर',
    compare: '{name} के साथ यह नंबर मिलाएँ। अगर यह एक जैसा है, तो बीच में कोई आपके मैसेज नहीं पढ़ सकता।',
    explainInfo: 'यह नंबर आप दोनों के सभी मौजूदा डिवाइस की एन्क्रिप्शन कुंजियों से बनता है और दोनों फ़ोन पर एक जैसा दिखता है। अगर आप में से कोई नया डिवाइस जोड़ता है, जैसे नया फ़ोन या वेब, तो नंबर बदल जाता है; तब इसे फिर से मिलाएँ। सत्यापन सिर्फ़ इसी डिवाइस पर रखा जाता है।',
    qrLabel: 'सुरक्षा नंबर का QR कोड',
    verified: 'सत्यापित',
    notVerified: 'सत्यापित नहीं',
    markVerified: 'सत्यापित के रूप में चिह्नित करें',
    clearVerified: 'सत्यापन हटाएँ',
    peerUnavailable: 'इस व्यक्ति के साथ एन्क्रिप्शन अभी चालू नहीं है।',
    selfUnavailable: 'इस डिवाइस की एन्क्रिप्शन कुंजी अभी तैयार नहीं है।',
    loadFailed: 'सुरक्षा नंबर लोड नहीं हो सका।',
  },
  backup: {
    title: 'चैट बैकअप',
    explainInfo: 'तुम्हारा इतिहास इसी डिवाइस पर है। बैकअप उसे तुम्हारे रिकवरी कोड से एन्क्रिप्ट करके सर्वर पर रखता है; हम उसे खोल नहीं सकते।',
    create: 'बैकअप बनाओ',
    refresh: 'बैकअप अपडेट करो',
    codeTitle: 'तुम्हारा रिकवरी कोड',
    codeWarning: 'इस कोड को सुरक्षित जगह रखो। खो गया तो इतिहास वापस नहीं आएगा, और हम भी उसे खोल नहीं सकते।',
    restoreTitle: 'इतिहास वापस लाओ',
    restorePlaceholder: 'रिकवरी कोड',
    restore: 'वापस लाओ',
    restored: '{count} मैसेज वापस आ गए।',
    restoreFailed: 'इतिहास खुल नहीं सका। कोड जाँचो।',
    failed: 'बैकअप नहीं बना।',
  },
  common: {
    infoHide: 'व्याख्या छिपाएँ: {subject}',
    infoShow: 'व्याख्या दिखाएँ: {subject}',
    continue: 'जारी रखें',
    cancel: 'रद्द करें',
    close: 'बंद करें',
    save: 'सेव करें',
    done: 'हो गया',
    retry: 'फिर कोशिश करें',
    error: 'त्रुटि',
    back: 'वापस',
    search: 'खोजें…',
    loading: 'लोड हो रहा है',
    remove: 'हटाएँ',
    offline: 'सर्वर तक नहीं पहुँच सके। कनेक्शन जाँचो।',
    sessionExpired: 'तुम्हारा सेशन खत्म हो गया। दोबारा साइन इन करो।',
    tooManyRequests: 'बहुत ज़्यादा अनुरोध हो गए। थोड़ा रुककर फिर कोशिश करो।',
  },
  time: {
    now: 'अभी',
    minAgo: '{n} मिनट पहले',
    hourAgo: '{n} घंटे पहले',
    yesterday: 'कल',
    dayAgo: '{n} दिन पहले',
    weekAgo: '{n} हफ्ते पहले',
    weekAgoOne: '{n} हफ़्ता पहले',
    today: 'आज',
    dayYesterday: 'कल',
  },
  phone: {
    sendFailed: "कोड भेजा नहीं जा सका। कृपया फिर कोशिश करें।",
    subtitle: 'अपना फ़ोन नंबर डालें',
    selectCountry: 'देश / क्षेत्र',
    countrySearch: 'देश खोजें…',
    architectureLink: 'तकनीकी आर्किटेक्चर और रोडमैप ↗',

  },
  otp: {
    verifyFailed: "कोड की पुष्टि नहीं हो सकी। कृपया फिर कोशिश करें।",
    invalidCode: "कोड अमान्य है या उसकी समय-सीमा समाप्त हो गई है।",
    rateLimited: "बहुत ज़्यादा प्रयास किए गए हैं। कृपया कुछ देर बाद फिर कोशिश करें।",
    title: 'कोड डालें',
    sentTo: 'हमने {phone} पर SMS भेजा है',
    verify: 'सत्यापित करें',
    resend: 'फिर से भेजें',

    tooManyAttempts: 'बहुत ज़्यादा कोशिशें हो गईं। थोड़ा रुककर फिर कोशिश करो।',

    resendSent: 'नया कोड भेज दिया गया।',
    resendFailed: 'कोड भेजा नहीं जा सका। कनेक्शन जाँचकर फिर कोशिश करो।',
    resendWait: '{n} स॰ बाद फिर माँग सकते हो',
  },
  university: {
    title: 'आपकी यूनिवर्सिटी कौन सी है?',
    subtitle: 'खोजकर ढूंढें',
    placeholder: 'हार्वर्ड, ऑक्सफ़ोर्ड…',
    skip: 'छोड़ें',
  },
  profession: {
    title: 'आप क्या काम करते हैं?',
    subtitle: 'अपना पेशा खोजें',
    placeholder: 'शिक्षक, डेवलपर, नर्स…',
    skip: 'छोड़ें',
  },
  isco: {
    '0': 'सशस्त्र बल',
    '1': 'प्रबंधक',
    '2': 'पेशेवर',
    '3': 'तकनीशियन और सह-पेशेवर',
    '4': 'लिपिकीय सहायक कर्मचारी',
    '5': 'सेवा और बिक्री कर्मचारी',
    '6': 'कृषि, वानिकी और मत्स्य पालन कर्मचारी',
    '7': 'शिल्प और संबंधित व्यापार कर्मचारी',
    '8': 'संयंत्र और मशीन ऑपरेटर',
    '9': 'प्राथमिक व्यवसाय',
  },
  isced: {
    '5': 'एसोसिएट डिग्री',
    '6': 'स्नातक',
    '7': 'परास्नातक',
    '8': 'पीएचडी',
  },
  profileCreate: {
    photoPickerFailed: "फ़ोटो लाइब्रेरी नहीं खुल सकी।",
    title: 'अपनी प्रोफ़ाइल बनाएं',
    addPhoto: 'फ़ोटो जोड़ें',
    name: 'आपका नाम',
    surname: 'आपका उपनाम',
  },
  terms: {
    title: 'शुरू करने से पहले',
    age: 'मेरी उम्र 18 साल से ऊपर है',
    accept: 'मैंने सेवा की शर्तें और गोपनीयता नीति पढ़ ली है और स्वीकार करता/करती हूं',
    termsLink: 'सेवा की शर्तें',
    privacyLink: 'गोपनीयता नीति',
    continue: 'स्वीकार करें और जारी रखें',
    saveFailed: 'तुम्हारी सहमति सेव नहीं हो सकी। कनेक्शन जाँचकर फिर कोशिश करो।',
    docPlaceholder: 'यह दस्तावेज़ जल्द ही प्रकाशित होगा।',
  },
  locationConsent: {
    title: 'स्थान, केवल आपकी अनुमति से',
    body: 'फ़ोटो लेने पर ज़िला और शहर सुझाने के लिए हमें स्थान की अनुमति चाहिए।',
    privacy: 'इस चरण में आपका स्थान नहीं पढ़ा जाता। सफलतापूर्वक फ़ोटो लेने के बाद ही इसका उपयोग होता है और आपके सटीक निर्देशांक संग्रहीत नहीं किए जाते। आप बाद में डिवाइस की सेटिंग में अनुमति बदल सकते हैं।',
    allow: 'स्थान की अनुमति दें',
    later: 'अभी नहीं',
  },
  discover: {
    title: "खोजें",
    categories: "पेशे की श्रेणियाँ",
    categoryHint: "प्रोफ़ाइल पर साझा किए गए पेशों के अनुसार लोगों को खोजें।",
    all: "सभी",
    reset: "फ़िल्टर हटाएँ",
    failed: 'लोड नहीं हो सका',
    free: 'मुफ़्त',
    empty: 'अभी यहां कोई नहीं है',
  },
  userProfile: {
    smsVerifiedOn: "SMS से फ़ोन सत्यापित · {date}",
    googleLinkedOn: "Google खाता जोड़ा गया · {date}",
    contactProofNote: "फ़ोन या Google खाते तक पहुँच की पुष्टि करता है, व्यक्ति की पहचान की नहीं।",
    failed: 'प्रोफ़ाइल लोड नहीं हो सकी',
    sendMessage: 'मैसेज भेजें',
    buyTime: 'मिलने का प्रस्ताव भेजें',
    block: 'ब्लॉक करें',
    blockedNotice: '{name} ब्लॉक है। मैसेज, कॉल और मुलाकात बंद हैं।',
    blockTitle: '{name} को ब्लॉक करें?',
    blockMessage: 'यह व्यक्ति अब आपको मैसेज नहीं भेज सकेगा और डिस्कवर में आपको नहीं ढूंढ सकेगा।',
    blockConfirm: 'ब्लॉक करें',
  },
  callHistory: {
    empty: 'अभी तक कोई कॉल नहीं',
    tabAll: 'सभी',
    tabMissed: 'मिस्ड',
    emptyMissed: 'कोई मिस्ड कॉल नहीं',
    failed: 'कॉल लोड नहीं हो सके',
    outgoing: 'आउटगोइंग',
    incoming: 'इनकमिंग',
    missed: 'छूटी',
    declined: 'अस्वीकृत',
    cancelled: 'रद्द',
  },
  call: {
    title: 'वॉइस कॉल',
    calling: 'कॉल हो रही है…',
    incoming: 'आने वाली कॉल',
    connecting: 'कनेक्ट हो रहा है…',
    connected: 'जुड़ गया',
    reconnecting: 'फिर से कनेक्ट हो रहा है…',
    logAnswered: 'वॉइस कॉल',
    logAnsweredVideo: 'वीडियो कॉल',
    logNoAnswer: 'कोई जवाब नहीं',
    logMissed: 'छूटी हुई कॉल',
    logDeclined: 'कॉल अस्वीकृत',
    logYouDeclined: 'आपने कॉल अस्वीकार की',
    logCancelled: 'कॉल रद्द की गई',
    ended: 'कॉल समाप्त',
    accept: 'उत्तर दें',
    decline: 'अस्वीकार करें',
    hangUp: 'कॉल काटें',
    close: 'बंद करें',
    mute: 'माइक्रोफ़ोन बंद करें',
    unmute: 'माइक्रोफ़ोन चालू करें',
    cameraOff: 'कैमरा बंद करें',
    cameraOn: 'कैमरा चालू करें',
    flipCamera: 'कैमरा बदलें',
    audioOutput: 'ऑडियो आउटपुट: {route}',
    audioOutputTitle: 'ऑडियो आउटपुट चुनें',
    earpiece: 'ईयरपीस',
    speaker: 'स्पीकर',
    bluetooth: 'ब्लूटूथ',
    bluetoothPermissionDenied: 'ब्लूटूथ की अनुमति बंद है। सेटिंग्स में इसे चालू करो।',
    wiredHeadset: 'वायर्ड हेडसेट',
    audioRouteFailed: 'ऑडियो आउटपुट नहीं बदला जा सका',
    acceptFailed: 'कॉल का जवाब नहीं दिया जा सका। फिर कोशिश करें।',
    declineFailed: 'कॉल अस्वीकार नहीं की जा सकी। फिर कोशिश करें।',
    endFailed: 'कॉल समाप्त नहीं की जा सकी। फिर कोशिश करें।',
    mediaConnectionFailed: 'ऑडियो कनेक्शन स्थापित नहीं हो सका। कॉल समाप्त हो गई और कोई शुल्क नहीं लिया गया।',
    remaining: '{time} शेष',
    endingSoon: 'यह कॉल जल्द समाप्त होगी।',
    spent: '{amount} खर्च',
    earned: '{amount} अर्जित',
    noAudioNotice: 'इस संस्करण में अभी ऑडियो प्रसारित नहीं होता। कॉल प्रवाह और बिलिंग का परीक्षण जारी है।',
    failed: 'कॉल शुरू नहीं हो सकी',
    insufficient: 'इस कॉल के लिए आपका बैलेंस कम है',
    busy: 'वे अभी दूसरी कॉल पर हैं',
    notAllowed: 'कॉल करने के लिए आप दोनों के बीच कम से कम एक मैसेज होना चाहिए',
    notAccepting: 'यह व्यक्ति अभी कॉल स्वीकार नहीं कर रहा',
    priceFree: 'मुफ़्त',
    priceChanged: 'कॉल की दर बदल गई है। नई दर देखकर दोबारा कोशिश करें।',
    rateLimited: 'आपने बहुत ज़्यादा बार कॉल करने की कोशिश की है। थोड़ी देर बाद फिर कोशिश करें।',
    reservationLinkUnavailable: 'यह बुकिंग अब इस कॉल से नहीं जोड़ी जा सकती। इसके बजाय आप सामान्य कॉल शुरू कर सकते हैं।',
    missed: 'छूटी हुई कॉल',
    callNow: 'अभी कॉल करें',
    videoNow: 'अभी वीडियो कॉल करें',
    scheduledStartTitle: 'निर्धारित कॉल',
    scheduledStartBody: '{name} के साथ निर्धारित कॉल शुरू हो रही है। अभी कॉल करें?',
    schedule: 'कॉल तय करें',
    scheduleTitle: '{name} के साथ कॉल तय करें',
    subjectPlaceholder: 'विषय (वैकल्पिक)',
    priceNote: 'कॉल दर: {price}',
    sendReservation: 'बुकिंग अनुरोध भेजें',
    reservationSent: 'अनुरोध भेजा गया',
    reservationSentBody: 'आपका कॉल बुकिंग अनुरोध {name} को भेज दिया गया।',
    reservationFailed: 'कॉल बुकिंग अनुरोध नहीं भेजा जा सका',
    reservationBubble: '☎️ कॉल बुकिंग का अनुरोध किया गया',
    reservationBubbleShort: '☎️ कॉल बुकिंग',
    reservationLabel: 'वॉइस कॉल बुकिंग',
    rescheduleBubble: '☎️ कॉल का नया समय प्रस्तावित हुआ',
    rescheduleBubbleShort: '☎️ कॉल का नया समय',
  },
  wallet: {
    title: 'वॉलेट',
    failed: 'वॉलेट लोड नहीं हो सका',
    availableBalance: 'उपलब्ध बैलेंस',
    earningsTitle: 'मेरी कमाई',
    earningsTotal: 'कुल कमाई',
    earningsWithdrawable: 'निकासी के लिए उपलब्ध',
    earningsEscrow: 'एस्क्रो में',
    addFunds: 'बैलेंस जोड़ें',
    addFundsDemo: 'डेमो: अपने अकाउंट में टेस्ट बैलेंस जोड़ें',
    addFundsFailed: 'बैलेंस नहीं जोड़ा जा सका।',
    topupLabel: 'बैलेंस जोड़ा गया',
    transactions: 'लेन-देन',
    noTransactions: 'अभी तक कोई लेन-देन नहीं',
    waiting: 'पेंडिंग',
    incomingRequest: 'आने वाला अनुरोध',
    replied: 'जवाब दिया गया',
    earned: 'कमाया गया',
    refunded: 'रिफ़ंड किया गया',
    requestPayout: 'निकासी करें',
    payoutHint: 'आप {amount} तक निकाल सकते हैं।',
    payoutAll: 'पूरी राशि चुनें',
    payoutRequested: 'अनुरोध प्राप्त हुआ',
    payoutRequestedBody: '{amount} की निकासी का अनुरोध बना दिया गया है, जल्द ही संसाधित किया जाएगा।',
    payoutFailed: 'निकासी अनुरोध नहीं बन सका',
    payoutRequests: 'निकासी अनुरोध',
    noPayouts: 'अभी तक कोई निकासी अनुरोध नहीं',
    payoutStatusPending: 'लंबित',
    payoutStatusPaid: 'भुगतान किया गया',
    payoutStatusRejected: 'अस्वीकृत',
    paymentAccount: 'भुगतान खाता',
    stripeConnect: 'भुगतान खाता जोड़ें',
    stripeConnectInfo: 'अपनी कमाई पाने के लिए बैंक खाता जोड़ें (Stripe, टेस्ट मोड)',
    stripeConnected: 'जुड़ा हुआ',
    stripeConnectFailed: 'कनेक्ट नहीं हो सका',
  },
  calendar: {
    dateInputLabel: "तारीख",
    timeInputLabel: "समय",
    dateInputHint: "साल, महीना और दिन YYYY-MM-DD प्रारूप में दर्ज करें।",
    timeInputHint: "समय 24 घंटे के HH:MM प्रारूप में दर्ज करें।",

    previousWeek: 'पिछला सप्ताह',
    nextWeek: 'अगला सप्ताह',
    empty: 'दिखाने के लिए कोई अनुरोध नहीं है',
    failed: 'कैलेंडर लोड नहीं हो सका',
    statusPending: 'लंबित',
    statusAccepted: 'स्वीकृत',
    statusDeclined: 'अस्वीकृत',
    statusCancelled: 'रद्द',
    statusExpired: 'अवधि समाप्त',
    accept: 'स्वीकार करें',
    decline: 'अस्वीकार करें',
    cancel: 'रद्द करें',
    cancelConfirmationTitle: 'यह आरक्षण रद्द करें?',
    cancelConfirmationAcceptedBody: '{name} के साथ पुष्ट आरक्षण रद्द हो जाएगा। दूसरे व्यक्ति को सूचना दी जाएगी और इस कार्रवाई को पूर्ववत नहीं किया जा सकेगा।',
    cancelConfirmationPendingBody: '{name} को भेजा गया प्रस्ताव वापस ले लिया जाएगा। दूसरे व्यक्ति को सूचना दी जाएगी और इस कार्रवाई को पूर्ववत नहीं किया जा सकेगा।',
    actionFailed: 'कार्रवाई विफल',
    proposeTitle: '{name} के साथ मिलने का प्रस्ताव भेजें',
    locationPlaceholder: 'कहाँ? (वैकल्पिक)',
    sendProposal: 'प्रस्ताव भेजें',
    proposalSent: 'प्रस्ताव भेजा गया',
    proposalSentBody: 'आपका मिलने का प्रस्ताव {name} को भेज दिया गया है।',
    priceChangedBody: 'इस बुकिंग की प्रति मिनट दर अब {amount} है। कोई प्रस्ताव नहीं बनाया गया — नई दर देखकर दोबारा प्रस्ताव भेजें।',
    proposalFailed: 'प्रस्ताव नहीं भेजा जा सका',
    meetupBubble: '📅 मिलने का प्रस्ताव भेजा गया',
    meetupBubbleShort: '📅 मिलने का प्रस्ताव',
    proposeAction: '📅 मिलने का प्रस्ताव भेजें',
    priceNote: 'मुलाकात की दर: {price}',
    totalCost: 'कुल: {amount}',
    minutesShort: 'मिनट',
    tabRequests: 'अनुरोध',
    tabCalendar: 'कैलेंडर',
    tabActive: 'वर्तमान',
    tabHistory: 'इतिहास',
    loadMore: 'और दिखाएँ',
    noEventsForDay: 'इस दिन कोई इवेंट नहीं',
    meetupLabel: 'आमने-सामने मुलाकात',
    reservationDetails: 'आरक्षण का विवरण',
    reservationParticipant: 'व्यक्ति',
    reservationHeld: 'कॉल हुई',
    reservationNotHeld: 'कोई कॉल नहीं हुई',
    reservationDateTime: 'तारीख और समय',
    reservationDuration: 'अवधि',
    reservationRate: 'प्रति मिनट',
    reservationLocation: 'स्थान',
    reservationSubject: 'विषय',
    reservationQuotedTotal: 'प्रस्तावित कुल',
    reservationBilledDuration: 'बिल की गई अवधि',
    reservationSpentAmount: 'भुगतान की गई राशि',
    reservationEarnedAmount: 'अर्जित राशि',
    reservationSettledAt: 'निपटान',
    reservationCreated: 'बनाया गया',
    reservationResponded: 'उत्तर दिया गया',
    reservationAcceptedAt: 'स्वीकार किया गया',
    reservationDeclinedAt: 'अस्वीकार किया गया',
    reservationCancelledAt: 'रद्द किया गया',
    reservationCancelledBy: 'रद्द करने वाला',
    reservationYou: 'आप',
    reservationCancellationNotification: 'सूचना प्रेषण',
    reservationNotificationPending: 'तैयार हो रहा है',
    reservationNotificationProviderAccepted: 'प्रेषण प्रदाता ने स्वीकार किया',
    reservationNotificationSuppressed: 'सूचना प्राथमिकताओं के कारण नहीं भेजा गया',
    reservationNotificationUnavailable: 'कोई योग्य डिवाइस नहीं मिला',
    reservationPendingReschedule: 'नया प्रस्तावित समय',
    reservationNewTime: 'नई तारीख और समय',
    proposeNewTime: 'नया समय सुझाएँ',
    rescheduleFuture: 'नया समय भविष्य में होना चाहिए और आरक्षण के मौजूदा शुरू होने के समय से कम से कम एक मिनट अलग होना चाहिए।',
    reservationCallTooEarly: 'यह निर्धारित कॉल शुरू होने से 15 मिनट पहले उपलब्ध होगी।',
    reservationCallExpired: 'इस आरक्षण की कॉल विंडो समाप्त हो गई है।',
    reservationCallInProgress: 'इस आरक्षण से जुड़ी कॉल पहले ही शुरू हो चुकी है।',
    reservationExecutionLocked: 'यह निर्धारित कॉल शुरू या समाप्त हो चुकी है, इसलिए अब इसे बदला नहीं जा सकता।',
    openReservation: '{name} के साथ आरक्षण का विवरण खोलें',
    systemEventMeetupTitle: '{name} के साथ मुलाकात',
    systemEventCallTitle: '{name} के साथ निर्धारित कॉल',
    systemEventNotes: 'nosubject के माध्यम से स्वीकृत।',
    systemCalendarCopyRemoved: 'सिस्टम कैलेंडर की कॉपी हटा दी गई',
    restoreSystemCalendarCopy: 'पुनर्स्थापित करें',
    systemCalendarRestoreFailed: 'कैलेंडर की कॉपी पुनर्स्थापित नहीं हो सकी। कैलेंडर कनेक्शन और सिस्टम अनुमति जाँचें।',
    systemCalendarCopyChanged: 'सिस्टम कैलेंडर का समय बदला गया',
    reviewSystemCalendarChange: 'समीक्षा करें',
    systemCalendarChangeTitle: 'कैलेंडर का समय बदला गया',
    systemCalendarChangeBody: 'यह बदलाव दूसरे व्यक्ति पर लागू नहीं हुआ।\n\nnosubject: {nosubject}\nसिस्टम कैलेंडर: {system}',
    restoreNosubjectTime: 'nosubject समय बहाल करें',
    systemCalendarTimeRestoreFailed: 'कैलेंडर कॉपी का समय ठीक नहीं हो सका। कैलेंडर कनेक्शन और सिस्टम अनुमति जाँचें।',
    proposeReschedule: 'दूसरे व्यक्ति को प्रस्ताव भेजें',
    rescheduleSent: 'नया समय प्रस्तावित हुआ',
    rescheduleSentBody: 'नए समय का प्रस्ताव {name} को भेजा गया। दूसरे व्यक्ति के स्वीकार करने तक आरक्षण का मौजूदा समय बना रहेगा।',
    rescheduleFailed: 'नया समय प्रस्तावित नहीं हो सका।',
    rescheduleActionFailed: 'समय का प्रस्ताव अपडेट नहीं हो सका।',
    reschedulePendingReceived: 'नए समय का प्रस्ताव: {time}',
    reschedulePendingSent: 'नया समय उत्तर की प्रतीक्षा में: {time}',
    withdrawReschedule: 'प्रस्ताव वापस लें',
    rescheduleBubble: '📅 मुलाकात का नया समय प्रस्तावित हुआ',
    rescheduleBubbleShort: '📅 मुलाकात का नया समय',
    connectionsTitle: 'कैलेंडर कनेक्शन',
    connectionsInfo: 'दिखाने के लिए कैलेंडर चुनें',
    deviceCalendar: 'डिवाइस कैलेंडर',
    connect: 'कनेक्ट करें',
    openSettings: 'सेटिंग खोलें',
    permissionGranted: 'एक्सेस दिया गया',
    permissionDenied: 'एक्सेस बंद है',
    permissionUnavailable: 'इस बिल्ड में उपलब्ध नहीं',
    permissionNotRequested: 'अभी कनेक्ट नहीं है',
    devicePermissionInfo: 'अनुमति केवल इस बटन को छूने पर माँगी जाती है। nosubject केवल चुने हुए कैलेंडर और आवश्यक समय सीमा पढ़ता है; इस स्क्रीन से इवेंट नहीं लिखता।',
    selectCalendars: 'दिखाए जाने वाले कैलेंडर',
    noDeviceCalendars: 'इस डिवाइस पर कोई इवेंट कैलेंडर उपलब्ध नहीं है।',
    manageSystemPermission: 'सिस्टम कैलेंडर अनुमति प्रबंधित करें',
    connectionPrivacyInfo: 'चयन इस डिवाइस पर इस खाते के लिए सहेजा जाता है। बाहरी विवरण केवल आपके दृश्य में उपयोग होंगे और अपने-आप साझा नहीं होंगे।',
    newBuildRequired: 'कैलेंडर कनेक्शन के लिए नया ऐप बिल्ड आवश्यक है।',
    connectionFailed: 'कैलेंडर कनेक्ट नहीं हो सका।',
    disconnect: 'डिस्कनेक्ट करें',
    disconnectTitle: 'कैलेंडर डिस्कनेक्ट करें?',
    disconnectBody: 'nosubject इस डिवाइस पर कैलेंडर पढ़ना और नए स्वीकृत इवेंट लिखना बंद कर देगा। चयन और स्थानीय मैपिंग मिटा दी जाएँगी; सिस्टम कैलेंडर के मौजूदा इवेंट बने रहेंगे। सिस्टम अनुमति को डिवाइस सेटिंग में अलग से रद्द किया जा सकता है।',
    disconnectFailed: 'कैलेंडर डिस्कनेक्ट नहीं हो सका।',
    selectionSaveFailed: 'कैलेंडर चयन सहेजा नहीं जा सका।',
    allDay: 'पूरे दिन',
    recurring: 'दोहराया जाता है',
    availabilityFree: 'उपलब्ध',
    availabilityBusy: 'व्यस्त',
    availabilityTentative: 'अनिश्चित',
    availabilityUnavailable: 'अनुपलब्ध',
    untitledExternalEvent: 'बिना शीर्षक का इवेंट',
    externalEventsFailed: 'बाहरी कैलेंडर इवेंट लोड नहीं हो सके।',
    hideExternalEvent: 'इस दृश्य से {title} छिपाएँ',
    hideExternalEventFailed: 'इवेंट छिपाया नहीं जा सका।',
    restoreHiddenExternalEvents: 'छिपे हुए इवेंट फिर दिखाएँ',
    restoreHiddenExternalEventsFailed: 'छिपे हुए इवेंट फिर नहीं दिखाए जा सके।',
    hiddenExternalEventCount: 'इस डिवाइस पर {count} इवेंट छिपे हैं',
    checkIncompleteTitle: 'कैलेंडर जाँच पूरी नहीं हुई',
    checkIncompleteBody: 'कम से कम एक कैलेंडर स्रोत अस्थायी रूप से पढ़ा नहीं जा सका, इसलिए हम पुष्टि नहीं कर सकते कि यह समय पूरी तरह खाली है। आप चाहें तो फिर भी जारी रख सकते हैं।',
    conflictCheckIncomplete: 'कुछ कैलेंडर पढ़े नहीं जा सके, इसलिए अन्य टकराव भी हो सकते हैं।',
    conflictTitle: 'कैलेंडर टकराव',
    reservationUnavailable: 'किसी अन्य पुष्ट आरक्षण के कारण यह समय अब उपलब्ध नहीं है।',
    reservationChanged: 'यह आरक्षण किसी अन्य स्क्रीन या डिवाइस पर बदल गया है। हमने इसका नवीनतम रूप लोड कर दिया है।',
    reservationPast: 'जिस आरक्षण का आरंभ समय बीत चुका है, उसे स्वीकार नहीं किया जा सकता।',
    conflictBody: 'यह समय आपके कैलेंडर के किसी अन्य इवेंट से टकराता है। आप चाहें तो फिर भी जारी रख सकते हैं।',
    tentativeConflictTitle: 'अनिश्चित कैलेंडर इवेंट',
    tentativeConflictBody: 'इस समय का एक कैलेंडर इवेंट अभी तय नहीं हुआ है। आगे बढ़ने से पहले विवरण देख लें।',
    conflictMore: '• अन्य इवेंट: {count}',
    continueAnyway: 'फिर भी जारी रखें',
    onlineCalendars: 'ऑनलाइन कैलेंडर',
    googleCalendar: 'Google कैलेंडर',
    providerConnected: 'कनेक्ट है',
    providerNotConnected: 'कनेक्ट नहीं है',
    providerUnavailable: 'आधिकारिक कनेक्शन तैयार किया जा रहा है',
    googlePrivacyInfo: 'सिर्फ़ आपके चुने हुए कैलेंडर सिंक होते हैं। शीर्षक और स्थान न्यूनतम सर्वर कैश में एन्क्रिप्ट किए जाते हैं; विवरण, प्रतिभागी और कॉन्फ़्रेंस लिंक सेव नहीं किए जाते। nosubject Google कैलेंडर के इवेंट बना, बदल या मिटा नहीं सकता।',
    googleConnectionFailed: 'Google कैलेंडर कनेक्शन शुरू नहीं हो सका।',
    microsoftCalendar: 'Microsoft कैलेंडर',
    microsoftInfo: 'nosubject केवल आपकी उपलब्धता पढ़ता है (Calendars.Read)। यह इवेंट बना, बदल या हटा नहीं सकता। पहुँच आपके Microsoft खाते की सेटिंग से हटाई जाती है; nosubject इसे स्वयं रद्द नहीं कर सकता।',
    microsoftConnectionFailed: 'Microsoft कैलेंडर कनेक्शन शुरू नहीं हो सका।',
    googleDisconnectTitle: 'Google कैलेंडर डिसकनेक्ट करें?',
    googleDisconnectBody: 'nosubject Google कैलेंडर डेटा का उपयोग बंद कर देगा और nosubject को दी गई Google अनुमतियाँ रद्द कर देगा। Google कैलेंडर के इवेंट नहीं मिटेंगे।',
    googleDisconnectFailed: 'Google कैलेंडर डिसकनेक्ट नहीं हो सका।',
    googleNoCalendars: 'पढ़े जा सकने वाले Google कैलेंडर नहीं मिले।',
    googleSelectionSaveFailed: 'Google कैलेंडर का चुनाव सेव नहीं हो सका।',
  },
  instagram: {
    title: 'Instagram कनेक्शन',
    connectInfo: 'स्पष्ट सहमति से अपना प्रोफ़ेशनल अकाउंट जोड़ें',
    connectedAccounts: 'जुड़े हुए अकाउंट',
    professionalAccount: 'प्रोफ़ेशनल अकाउंट',
    connect: 'जोड़ें',
    reconnect: 'फिर से जोड़ें',
    connectedAs: '@{username} · {accountType}',
    notConnected: 'अभी जुड़ा नहीं है',
    unavailable: 'आधिकारिक कनेक्शन तैयार किया जा रहा है',
    privacyInfo: 'पहले चरण में प्रोफ़ेशनल अकाउंट की पहचान पढ़ने के लिए केवल instagram_business_basic माँगा जाता है। मैसेज, टिप्पणी या प्रकाशन की अनुमति नहीं माँगी जाती और अलग से आयात चुनने तक कोई फ़ोटो nosubject में कॉपी नहीं होती।',
    business: 'व्यवसाय',
    creator: 'क्रिएटर',
    connectionFailed: 'Instagram कनेक्शन शुरू नहीं हो सका।',
  },
  inbox: {
    markUnread: 'अपठित के रूप में चिह्नित करें',
    markRead: 'पढ़ा हुआ चिह्नित करें',
    archiveTitle: 'आर्काइव',
    archive: 'आर्काइव',
    failed: 'बातचीत लोड नहीं हो सकी',
    searchEmpty: 'कोई परिणाम नहीं',
    archivedEmpty: 'कोई आर्काइव्ड बातचीत नहीं',
    empty: 'अभी तक कोई बातचीत नहीं',
    you: 'आप:',
    archived: 'आर्काइव किया गया',
    unarchived: 'आर्काइव से हटाया गया',
    undo: 'पूर्ववत करें',
    mute: 'म्यूट करें',
    muteTitle: '{name} को म्यूट करें',
    mute1h: '1 घंटे के लिए',
    mute8h: '8 घंटे के लिए',
    mute1w: '1 हफ्ते के लिए',
    muteForever: 'जब तक मैं इसे बंद न करूं',
    unmute: 'अनम्यूट करें',
    archiveAction: 'आर्काइव करें',
    unarchiveAction: 'आर्काइव से हटाएँ',
    swipeRemove: 'आर्काइव से हटाएँ',
    swipeArchive: 'आर्काइव करें',
    blockAction: 'ब्लॉक करें',
    blockTitle: '{name} को ब्लॉक करें?',
    blockMessage: 'यह व्यक्ति अब आपको मैसेज नहीं भेज सकेगा और डिस्कवर में आपको नहीं ढूंढ सकेगा।',
    blockConfirm: 'ब्लॉक करें',
  },
  message: {
    translationLanguage: "अनुवाद की भाषा",
    chooseTranslationLanguage: "अनुवाद की भाषा चुनें",
    languageSuggestion: "डिवाइस की भाषा का सुझाव",
    translationLanguageInfo: "यह निजी पसंद आपकी सभी बातचीत के अनुवाद पर लागू होती है। इसे आपकी प्रोफ़ाइल में नहीं जोड़ा जाता।",
    photoCaption: "फ़ोटो में विवरण जोड़ें…",
    removePhoto: "फ़ोटो हटाएँ",
    star: "स्टार लगाएँ",
    unstar: "स्टार हटाएँ",
    starred: "स्टार वाले मैसेज",
    noStars: "इस बातचीत में कोई स्टार वाला मैसेज नहीं है।",
    starFailed: "स्टार अपडेट नहीं हो सके। फिर कोशिश करें।",
    starredAttachment: "अटैचमेंट वाला मैसेज",
    edit: "मैसेज एडिट करें",
    edited: "संपादित",
    editInfo: "पढ़ने की पुष्टि बंद होने पर भी मैसेज पढ़े जाने तक एडिट कर सकते हैं। एडिट का विकल्प गायब होने से पढ़े जाने का पता चल सकता है। अपठित का मतलब अनदेखा नहीं है: पहला टेक्स्ट नोटिफ़िकेशन के प्रीव्यू में दिख सकता है। एडिट करने से अपनी बात वापस लेने की गारंटी नहीं मिलती।",
    editFailed: "बदलाव की पुष्टि नहीं हुई। मैसेज पढ़ा या बदला जा चुका हो सकता है। फिर से कोशिश करने से पहले चैट देखें।",
    copy: "कॉपी करें",
    copyFailed: "मैसेज कॉपी नहीं हो सका। कृपया फिर से कोशिश करें।",
    inputPlaceholder: 'मैसेज लिखें…',
    typing: 'टाइप कर रहे हैं',
    translate: 'अनुवाद करें',
    withdrawn: 'मैसेज वापस ले लिया गया',
    linkOpenTitle: 'लिंक खोलें',
    linkOpenBody: 'यह आपको {host} पर ले जाएगा। यह लिंक आपको मैसेज भेजने वाले व्यक्ति ने भेजा है — अगर आप उन्हें नहीं जानते तो सावधान रहें।',
    linkOpenConfirm: 'खोलें',
    linkOpenFailed: 'लिंक नहीं खुल सका।',
    seenAt: 'देखा {time}',

    priceChangedTitle: 'कीमत बदल गई',
    priceChangedBody: 'इस मैसेज की कीमत अब {old} नहीं, {new} है। फिर भी भेजें?',
    priceChangedSend: 'भेजें',
    priceNoticeTitle: 'इस व्यक्ति से बात करने का खर्च',
    priceNoticeMessage: 'हर मैसेज {amount}',
    priceNoticeCall: 'कॉल {amount}',
    priceNoticePersonal: 'ये दरें खास आपके लिए तय की गई हैं।',
    priceDecreasedTitle: "मैसेज की कीमत कम हुई",
    priceDecreasedBody: "मैसेज की कीमत अब {old} की जगह {new} है। कम कीमत के लिए पुष्टि की ज़रूरत नहीं है।",
    priceChange: {
      free: 'मुफ़्त',
    },
    expired: 'समय सीमा समाप्त, रिफ़ंड किया गया',
    // 9.2 / D-650 — web'den gönderilen mesajın saat satırındaki notu.
    sentFromWeb: 'वेब से',
    linkViewLabel: 'लिंक का रूप',
    linkViewPlain: 'सादा पता',
    linkViewCompact: 'छोटा',
    linkViewCard: 'बड़ा कार्ड',
    linkPreviewLoading: 'प्रीव्यू तैयार हो रहा है…',
    linkPreviewFailed: 'इस लिंक का प्रीव्यू नहीं मिल सका; यह सादे पते के रूप में जाएगा।',
    linkPreviewA11y: 'लिंक: {title}, {host}',
    customPrice: 'कस्टम कीमत',
    priceUsesGeneral: 'मेरी सामान्य कीमत लागू होती है',
    priceRemove: 'संपर्कों से हटाएँ',
    priceRemoveTitle: '{name} को अपने संपर्कों से हटाएँ?',
    priceRemoveBody: 'कस्टम कीमत हट जाएगी और {name} पर आपकी सामान्य कीमत लागू होगी। अगर सिर्फ़ आपके संपर्क आपको मैसेज कर सकते हैं, तो यह व्यक्ति नई बातचीत शुरू नहीं कर सकेगा। यह ब्लॉक करना नहीं है।',
    priceRemoveConfirm: 'हटाएँ',
    priceRemoved: '{name} पर अब आपकी सामान्य कीमत लागू है।',
    pricePrompt: '{name} के लिए कीमतें (0 = मुफ़्त):',
    saved: 'सेव हो गया',
    priceFreeSet: '{name} अब आपको मुफ़्त में मैसेज कर सकता/सकती है।',
    priceSet: '{name} के लिए कीमत {price} तय की गई।',
    saveError: 'सेव नहीं हो सका।',
    photoError: 'फ़ोटो नहीं भेजी जा सकी।',
    noConnection: 'कोई कनेक्शन नहीं',
    checkInternet: 'अपना इंटरनेट कनेक्शन जांचें।',
    sendError: 'मैसेज नहीं भेजा जा सका।',
    addAttachment: 'अटैचमेंट जोड़ें',
    sendMessageAction: 'मैसेज भेजें',
    lowBalanceTitle: 'बैलेंस कम है',
    lowBalanceBody: 'आपका बैलेंस इस व्यक्ति की मैसेज कीमत से कम है। बैलेंस जोड़ें और फिर कोशिश करें।',
    reply: 'जवाब दें',
    reactionA11y: '{emoji} प्रतिक्रिया, कुल {count}',
    reactionA11yMine: '{emoji} प्रतिक्रिया, कुल {count}, आपकी भी शामिल',
    reactionAdd: '{emoji} से प्रतिक्रिया दें',
    moreReactions: 'और इमोजी',
    reactionRemove: 'अपनी {emoji} प्रतिक्रिया हटाएँ',
    you: 'आप',
    photo: '📷 फ़ोटो',
    takePhoto: 'फ़ोटो लें',
    choosePhoto: 'गैलरी से चुनें',
    chooseVideo: 'वीडियो चुनें',
    recordVoice: 'वॉइस मैसेज',
    micPermissionTitle: 'माइक्रोफ़ोन की अनुमति चाहिए',
    micPermissionBody: 'वॉइस मैसेज रिकॉर्ड करने के लिए माइक्रोफ़ोन की अनुमति चाहिए।',
    voiceError: 'वॉइस मैसेज नहीं भेजा जा सका',
    voiceRecording: 'रिकॉर्डिंग',
    videoTooLarge: 'वीडियो बहुत बड़ा है (अधिकतम 1 GB)',
    videoTooLong: 'वीडियो बहुत लंबा है (अधिकतम 10 मिनट)',
    videoError: 'वीडियो नहीं भेजा जा सका',
    videoNeedsUpdate: 'यह वीडियो देखने के लिए ऐप अपडेट करें',
    voiceNeedsUpdate: 'यह वॉइस मैसेज सुनने के लिए ऐप अपडेट करें',
    voiceOrderTitle: 'वॉइस मैसेज का ऑर्डर दिया',
    encrypted: 'एन्क्रिप्टेड मैसेज',
    identityChanged: 'इस व्यक्ति की सुरक्षा कुंजी बदल गई। आमतौर पर इसका मतलब नया फ़ोन या दोबारा इंस्टॉल किया गया ऐप है।',
    identityChangedVerify: 'आपने यह चैट सत्यापित की थी; सुरक्षा नंबर फिर से मिलाएँ।',
    unencrypted: 'यह चैट एन्क्रिप्टेड नहीं है',
    unencryptedPeerInfo: 'दूसरे व्यक्ति का ऐप अभी एंड-टू-एंड एन्क्रिप्शन सपोर्ट नहीं करता, इसलिए आप यहाँ जो लिखते हैं वह बिना एन्क्रिप्शन के जाता है और nosubject के सर्वर पर पढ़ा जा सकता है। जब वे अपना ऐप अपडेट करेंगे, नए मैसेज अपने आप एन्क्रिप्ट होकर जाएँगे।',
    unencryptedOfficialInfo: 'यह nosubject का आधिकारिक अकाउंट है। आप यहाँ जो लिखते हैं वह बिना एन्क्रिप्शन के जाता है और nosubject टीम उसे पढ़ सकती है।',
    unencryptedSelfInfo: 'इस डिवाइस पर एन्क्रिप्शन चालू नहीं हो सका (जैसे ब्राउज़र की प्राइवेट विंडो कुंजियाँ नहीं रख सकती)। आप यहाँ से जो भेजते हैं वह बिना एन्क्रिप्शन के जाता है और nosubject के सर्वर पर पढ़ा जा सकता है।',
    notificationOfferEnable: 'सूचनाएँ चालू करें',
    notificationOfferEnabled: 'सूचनाएँ चालू हैं',
    voiceOrderPending: 'डिलीवरी का इंतज़ार',
    voiceOrderDelivered: 'मिल गया',
    voiceOrderDeclined: 'मना किया, पैसे वापस',
    voiceOrderExpired: 'समय खत्म, पैसे वापस',
    voiceOrderAction: 'वॉइस मैसेज मँगवाएँ',
    voiceOrderPick: 'कितनी लंबी रिकॉर्डिंग?',
    voiceOrderInsufficient: 'इस ऑर्डर के लिए बैलेंस कम है।',
    voiceOrderError: 'ऑर्डर नहीं हो सका।',
    voiceOrderRecord: 'रिकॉर्ड करके भेजें',
    voiceOrderDecline: 'मना करें',
    voiceOrderDeclineTitle: 'ऑर्डर मना करें',
    voiceOrderDeclineBody: 'रोकी गई पूरी रकम मँगवाने वाले को वापस चली जाएगी।',
    voiceOrderDeclineError: 'ऑर्डर मना नहीं किया जा सका।',
    voiceOrderDeliverError: 'रिकॉर्डिंग नहीं भेजी जा सकी।',
    voiceOrderRecording: 'ऑर्डर की रिकॉर्डिंग',
    voiceOrderRemaining: '{length} बाकी',
    voiceOrderShortNote: 'छोटी भेजेंगे तो जितना रिकॉर्ड किया उतने का ही पैसा लगेगा।',
    voiceOrderRefunded: '{amount} वापस',
    sendLocation: 'लोकेशन भेजें',
    locationTitle: 'लोकेशन',
    locationError: 'लोकेशन नहीं भेजी जा सकी',
    shareLiveLocation: 'लाइव लोकेशन शेयर करें',
    liveLocationHour: '1 घंटा',
    liveLocationEightHours: '8 घंटे',
    liveLocationOpenEnded: 'जब तक मैं बंद न करूँ',
    liveLocationSharing: 'आपकी लाइव लोकेशन शेयर हो रही है',
    liveLocationStop: 'बंद करें',
    liveLocationError: 'लाइव लोकेशन शुरू नहीं हो सकी',
    liveLocationCardTitle: 'लाइव लोकेशन',
    liveLocationCardActive: 'अभी शेयर हो रही है',
    liveLocationCardEnded: 'शेयरिंग खत्म',
    liveLocationOpen: 'लोकेशन देखें',
    liveLocationNoPoint: 'अभी कोई पोज़िशन नहीं',
    liveLocationOpenInMaps: 'मैप्स में खोलें',
    liveLocationUpdatedAgo: '{ago} अपडेट हुई',
    videoShort: '🎬 वीडियो',
    voiceShort: '🎙 वॉइस मैसेज',
    liveLocationWatchedAgo: '{ago} पहले देखा',
    liveLocationNotWatched: 'अभी तक नहीं देखा',
    liveLocationSharerSeesYou: 'आप कब देखते हैं, वे देख सकते हैं',
    cameraPermissionTitle: 'कैमरा एक्सेस आवश्यक है',
    cameraPermissionBody: 'फ़ोटो लेने के लिए कैमरा एक्सेस की अनुमति दें।',
    cameraError: 'कैमरा नहीं खुल सका।',
    photoLocationTitle: 'फ़ोटो का स्थान',
    photoLocationPromptFile: 'फ़ोटो फ़ाइल से {place} पढ़ा गया। क्या यह स्थान फ़ोटो के साथ दिखाया जाए?',
    photoLocationPromptCapture: 'डिवाइस की लोकेशन से {place} मिला। क्या यह स्थान फ़ोटो के साथ दिखाया जाए?',
    photoLocationHide: 'स्थान के बिना भेजें',
    photoLocationShare: 'स्थान के साथ भेजें',
    photoLocationFromFile: 'फ़ाइल से लिया गया',
    photoLocationFromCapture: 'डिवाइस की लोकेशन',
    photoLocationHideAfter: 'स्थान छिपाएँ',
    photoLocationShowAfter: 'स्थान दिखाएँ',
    photoLocationUpdateError: 'फ़ोटो का स्थान अपडेट नहीं किया जा सका।',
  },
  versionNotice: {
    title: 'नया वर्शन उपलब्ध है',
    body: 'सुरक्षा सुधारों और नई सुविधाओं के लिए ऐप अपडेट करें।',
    update: 'अपडेट करें',
  },
  notifications: {
    title: 'सूचनाएँ',
    cardBody: 'नए मैसेज और जवाब न छूटें, इसके लिए डिवाइस सूचनाएँ चालू करें।',
    notNow: 'अभी नहीं',
    enable: 'सूचनाएँ चालू करें',
    device: 'डिवाइस सूचनाएँ',
    stateOn: 'चालू · सिस्टम सेटिंग में प्रबंधित करें',
    stateOff: 'बंद · सिस्टम सेटिंग में चालू करें',
    stateAsk: 'अभी पूछा नहीं गया',
    preferences: 'सूचना प्राथमिकताएँ',
    preferencesInfo: 'श्रेणियाँ, पूर्वावलोकन और डिवाइस अनुमति प्रबंधित करें',
    stateUnsupported: 'इस डिवाइस पर समर्थित नहीं है',
    master: 'सभी सूचनाएँ',
    masterInfo: 'इसे बंद करने पर सभी पुश सूचनाएँ रुक जाती हैं, लेकिन श्रेणियों के चुने हुए विकल्प बने रहते हैं',
    categories: 'श्रेणियाँ',
    categoryEnabled: 'इस श्रेणी की सूचनाएँ',
    categoryEnabledInfo: 'इसे बंद करने पर इस श्रेणी की पुश सूचनाएँ रुक जाती हैं, लेकिन इसके चुने हुए विकल्प बने रहते हैं',
    events: 'घटनाएँ',
    messages: 'मैसेज',
    messagesInfo: 'नए मैसेज और जवाब',
    meetups: 'मुलाकातें',
    meetupsInfo: 'प्रस्ताव, बदलाव और परिणाम',
    meetupRequests: 'नई मुलाकात के प्रस्ताव',
    meetupRequestsInfo: 'जब कोई नई मुलाकात का प्रस्ताव भेजे',
    meetupUpdates: 'जवाब और रद्दीकरण',
    meetupUpdatesInfo: 'जब मुलाकात स्वीकार, अस्वीकार या रद्द हो',
    meetupReminders: 'मुलाकात रिमाइंडर',
    meetupRemindersInfo: 'जब स्वीकार की गई मुलाकात पास आए',
    calls: 'कॉल',
    callsInfo: 'आने वाली, निर्धारित और छूटी हुई कॉल',
    incomingCalls: 'आने वाली कॉल',
    incomingCallsInfo: 'जब कोई आपको कॉल करे तो ध्वनि अलर्ट',
    callRequests: 'निर्धारित कॉल के प्रस्ताव',
    callRequestsInfo: 'जब प्रस्ताव बने, स्वीकार हो, अस्वीकार हो या रद्द हो',
    callReminders: 'निर्धारित कॉल के रिमाइंडर',
    callRemindersInfo: 'जब स्वीकार की गई निर्धारित कॉल का समय नज़दीक आए',
    missedCalls: 'छूटी हुई कॉल',
    missedCallsInfo: 'जब आप किसी कॉल का जवाब न दे सकें',
    financial: 'धन और एस्क्रो',
    financialInfo: 'लेन-देन स्थिति में बदलाव',
    financialEarnings: 'कमाई और एस्क्रो',
    financialEarningsInfo: 'जब एस्क्रो जारी हो या कमाई उपलब्ध हो',
    financialRefunds: 'रिफंड और समय समाप्ति',
    financialRefundsInfo: 'जब भुगतान वापस हो या एस्क्रो की अवधि समाप्त हो',
    financialPayouts: 'निकासी के परिणाम',
    financialPayoutsInfo: 'जब निकासी अनुरोध सफल या विफल हो',
    reactions: 'इमोजी प्रतिक्रियाएँ',
    reactionsInfo: 'आपके मैसेज पर प्रतिक्रियाएँ',
    official: 'Nosubject से',
    officialInfo: 'संस्करण, सुरक्षा और आपके खाते के बारे में Nosubject की घोषणाएँ। यह बाकी सूचनाओं से अलग है; इसे बंद करने पर Nosubject सूचनाएँ नहीं भेजेगा, लेकिन उसके मैसेज इनबॉक्स में आते रहेंगे।',
    preview: 'मैसेज पूर्वावलोकन',
    previewHidden: 'छिपा हुआ',
    previewHiddenInfo: 'भेजने वाला और मैसेज दोनों न दिखाएँ',
    previewSender: 'केवल भेजने वाला',
    previewSenderInfo: 'भेजने वाला दिखाएँ, मैसेज छिपाएँ',
    previewText: 'भेजने वाला और मैसेज',
    previewTextInfo: 'अधिकतम 80 अक्षर दिखाएँ',
    deviceInfo: 'सिस्टम अनुमति केवल इस डिवाइस के लिए है',
    openSettings: 'सेटिंग खोलें',
    centerTitle: 'सूचना केंद्र',
    centerMarkAll: 'सभी को पढ़ा हुआ चिह्नित करें', centerMarkedAll: 'सभी को पढ़ा हुआ चिह्नित किया गया',
    centerEmpty: 'अभी कोई सूचना नहीं है।',
    centerFailed: 'सूचनाएँ लोड नहीं हो सकीं।',
    centerMarkAllFailed: 'सूचनाओं को पढ़ा हुआ नहीं किया जा सका।',
    centerUnknownPerson: 'किसी',
    centerEscrowExpiredRefunded: 'एस्क्रो की अवधि समाप्त · भुगतान वापस किया गया',
    centerEscrowReleasedEarning: 'उत्तर पूरा · कमाई जोड़ी गई',
    centerMeetupRequest: '{name} ने मिलने का प्रस्ताव भेजा',
    centerCallRequest: '{name} ने निर्धारित कॉल का प्रस्ताव भेजा',
    centerCallReminder: '{name} के साथ निर्धारित कॉल का समय नज़दीक है',
    centerCallStarting: '{name} के साथ निर्धारित कॉल शुरू हो रही है',
    centerMeetupStarting: '{name} के साथ मुलाक़ात शुरू हो रही है',
    centerMeetupReminder: '{name} के साथ मुलाक़ात जल्द है',
    centerMeetupUpdate: '{name} · मुलाकात: {status}',
    centerCallUpdate: '{name} · निर्धारित कॉल: {status}',
    centerMeetupRescheduleRequest: '{name} ने मुलाकात का नया समय प्रस्तावित किया',
    centerCallRescheduleRequest: '{name} ने कॉल का नया समय प्रस्तावित किया',
    centerMeetupRescheduleUpdate: '{name} · मुलाकात का नया समय: {status}',
    centerCallRescheduleUpdate: '{name} · कॉल का नया समय: {status}',
    centerBell: 'सूचना केंद्र',
    centerBellUnread: 'सूचना केंद्र, अपठित: {count}',
  },
  profile: {
    webVisibility: 'मेरा वेब पेज कौन देख सकता है',
    webVisibilityLink: 'लिंक वाले',
    webVisibilityInfo: 'बिना अकाउंट वाले लोगों को दिखने वाली आपकी प्रोफ़ाइल: nosubject.co/आपका-यूज़रनेम वाला आपका पेज। सभी: आपका पेज सर्च इंजन में भी दिख सकता है। लिंक वाले: जिसके पास पता है, वह इसे खोल सकता है; सर्च इंजन इसे नहीं दिखाते। इन दोनों में बिना अकाउंट वाले लोग आपकी प्रोफ़ाइल की जानकारी, आपके आख़िरी बार ऑनलाइन होने का समय भी, पा सकते हैं। कोई नहीं: बिना अकाउंट वाला कोई भी आपकी प्रोफ़ाइल नहीं देख सकता; पेज “यह प्रोफ़ाइल उपलब्ध नहीं है” दिखाता है। ऐप में आपकी प्रोफ़ाइल नहीं बदलती। सर्च नतीजों से हटने में कुछ दिन लग सकते हैं।',
    linkViewInfo: 'चुनें कि आपका लिखा लिंक कैसे जाए। छोटा और बड़ा कार्ड के लिए आपका फ़ोन पेज एक बार खोलता है और प्रीव्यू को मैसेज के साथ भेजता है; वह साइट आपके फ़ोन का IP पता देखती है। एन्क्रिप्टेड चैट में प्रीव्यू एन्क्रिप्शन के अंदर रहता है; बिना एन्क्रिप्शन वाली चैट में nosubject लिंक और प्रीव्यू देख सकता है। सादा पता कोई पेज नहीं खोलता। वेब से भेजे गए लिंक हमेशा सादे पते के रूप में जाते हैं।',
    linkViewAsk: 'लिखते समय विकल्प दिखाएँ',
    linkViewAskInfo: 'चालू होने पर लिंक लिखते समय बाकी दो रूप भी दिखते हैं और आप उस मैसेज के लिए एक चुन सकते हैं। बंद होने पर लिंक हमेशा यहाँ चुने गए रूप में जाता है।',
    whoCanCallInfo: 'चुनें कि कौन आपको कॉल कर सकता है; यह हर कॉल पर लागू होता है। मेरे संपर्क वे लोग हैं जिनके लिए आपने निजी कीमत तय की है। अपवाद में आप एक-एक व्यक्ति को अनुमति दे या रोक सकते हैं।',
    whoCanMessageInfo: 'चुनें कि कौन आपसे नई बातचीत शुरू कर सकता है; पहले से चल रही बातचीत पर असर नहीं पड़ता। मेरे संपर्क वे लोग हैं जिनके लिए आपने निजी कीमत तय की है। अपवाद में आप एक-एक व्यक्ति को अनुमति दे या रोक सकते हैं।',
    readReceiptsInfo: "पढ़ने की पुष्टि तभी दिखती है जब दोनों इसे चालू करें। बंद होने पर भी संपादन विकल्प गायब होने से पढ़े जाने का पता चल सकता है।",
    showTypingInfo: 'चालू होने पर, जिसे आप लिख रहे हैं वह देख सकता है कि आप टाइप कर रहे हैं। बंद करने पर यह किसी को नहीं दिखता, और आप फिर भी देख पाते हैं कि दूसरे कब टाइप कर रहे हैं।',
    officialAccount: 'आधिकारिक खाता',
    information: 'प्रोफ़ाइल जानकारी',
    logout: 'लॉग आउट',
    account: 'अकाउंट',
    accountData: 'अकाउंट और डेटा',
    name: 'नाम',
    surname: 'उपनाम',
    username: 'यूज़रनेम',
    usernamePlaceholder: 'यूज़रनेम',
    usernameChecking: 'जांच हो रही है…',
    usernameAvailable: 'उपलब्ध है',
    usernameTaken: 'यह यूज़रनेम पहले से लिया जा चुका है',
    usernameInvalid: '3–20 वर्ण; पहला वर्ण A–Z या a–z हो। केवल A–Z, a–z, 0–9 और _ इस्तेमाल करें।',
    usernameAdd: 'यूज़रनेम जोड़ें',
    profession: 'पेशा',
    professionNone: 'कोई पेशा नहीं जोड़ा गया',
    professionAdd: 'पेशा जोड़ें',
    employer: 'कंपनी',
    employerPlaceholder: 'कंपनीकायूज़रनेम',
    employerInfo: 'nosubject का कोई मौजूदा यूज़रनेम लिखें। इस उल्लेख का अर्थ यह नहीं है कि कार्यस्थल सत्यापित है।',
    employerNotFound: 'उस यूज़रनेम वाला कोई सक्रिय अकाउंट नहीं मिला।',
    employerSelf: 'आप अपने अकाउंट को अपनी कंपनी के रूप में नहीं दिखा सकते।',
    bio: 'अपने बारे में बताएं…',
    prices: 'कीमतें',
    settings: 'सेटिंग',
    priceMessage: 'मैसेज',
    priceVoice: 'वॉइस मैसेज (प्रति मिनट)',
    priceVoiceShort: 'वॉइस मैसेज',
    priceCall: 'अभी कॉल करें (प्रति मिनट)',
    priceCallShort: 'अभी कॉल करें',
    priceScheduledCall: 'कॉल शेड्यूल करें (प्रति मिनट)',
    priceScheduledCallShort: 'कॉल शेड्यूल करें',
    priceVideoCall: 'वीडियो कॉल',
    priceVideoCallShort: 'वीडियो',
    priceTime: 'मुलाकात (प्रति मिनट)',
    priceTimeShort: 'मुलाकात',
    currency: 'मुद्रा',
    saving: 'सेव हो रहा है…',
    wallet: 'वॉलेट',
    chatBackup: 'चैट बैकअप',
    privacy: 'गोपनीयता',
    readReceipts: 'पढ़ने की पुष्टि',
    showTyping: 'टाइपिंग संकेत',
    keepArchived: 'आर्काइव में रखें',
    keepArchivedInfo: 'अगर बंद है, तो नया मैसेज बातचीत को आर्काइव से बाहर कर देगा',
    whoCanMessage: 'मुझे कौन मैसेज कर सकता है',
    whoCanCall: 'मुझे कौन कॉल कर सकता है',
    messagesFromContact: 'इस व्यक्ति के मैसेज',
    callsFromContact: 'इस व्यक्ति से कॉल',
    callExceptions: 'अपवाद',
    callExceptionsEmpty: 'अभी कोई कॉल अपवाद नहीं',
    messageExceptionsEmpty: 'अभी कोई मैसेज अपवाद नहीं',
    exceptionsLoadFailed: 'अपवाद लोड नहीं हो सके',
    openProfileHint: 'इस व्यक्ति की प्रोफ़ाइल खोलता है',
    callExceptionBlocked: 'ब्लॉक किया गया',
    callsFromContactDefault: 'डिफ़ॉल्ट',
    callsFromContactAllow: 'हमेशा अनुमति दें',
    callsFromContactBlock: 'कभी नहीं',
    everyone: 'सभी',
    contacts: 'मेरे संपर्क',
    nobody: 'कोई नहीं',
    blockedUsers: 'ब्लॉक किए गए यूज़र्स',
    blockedEmpty: 'आपने किसी को ब्लॉक नहीं किया',
    unblock: 'अनब्लॉक करें',
    appearance: 'रूप-रंग',
    light: 'लाइट',
    dark: 'डार्क',
    system: 'सिस्टम',
    displayLanguage: 'ऐप की भाषा',
    education: 'यूनिवर्सिटी',
    educationAdd: 'यूनिवर्सिटी जोड़ें',
    educationNone: 'कोई यूनिवर्सिटी नहीं जोड़ी गई',
    educationLevel: 'स्तर',
    searchLanguage: 'भाषा खोजें…',
    photoChange: 'बदलें',
    saveFailed: 'सेव नहीं हो सका।',
    photoFailed: 'फ़ोटो अपलोड नहीं हो सकी।',
    photoChanged: "फ़ोटो किसी दूसरी कार्रवाई में बदल गई है या दोबारा कोशिश करने का समय समाप्त हो गया है। कृपया फ़ोटो फिर से चुनें।",
    deleteAccount: 'अकाउंट डिलीट करें',
    deleteTitle: 'अपना अकाउंट डिलीट करें',
    deleteMessage: 'आपका अकाउंट 30 दिन बाद पूरी तरह डिलीट हो जाएगा। इस दौरान आप दोबारा लॉग इन करके इसे रद्द कर सकते हैं।',
    deleteMoneyWarning: 'आपके वॉलेट और एस्क्रो में {amount} है। डिलीट करने से पहले इसे निकाल लेने की सलाह दी जाती है।',
    deleteConfirm: 'डिलीट करें',
    deleteFailed: 'अकाउंट डिलीट नहीं हो सका।',
    deletionScheduled: 'आपका अकाउंट {date} को डिलीट हो जाएगा।',
    deletionCancel: 'अकाउंट डिलीट करना रद्द करें',
    exportData: 'मेरा डेटा डाउनलोड करें',
    exportFailed: 'डेटा नहीं मिल सका।',
  },
  // Alt bar (dock) — ekran okuyucu etiketleri ve rozet sayıları (9.26.7.2.1)
  dock: {
    calls: 'कॉल',
    discover: 'खोजें',
    inbox: 'मैसेज',
    calendar: 'कैलेंडर',
    profile: 'प्रोफ़ाइल',
    unreadMessages: '{count} अपठित',
    pendingRequests: '{count} लंबित',
  },
};
